import React, { useState } from "react";

// External
import styled from "styled-components";
// import { FiMenu, FiX } from "react-icons/fi";
import { useLocation } from "@reach/router";
import {
  FiMail,
  FiGithub,
  FiInstagram,
  FiLinkedin,
  FiTwitter,
  FiMenu,
  FiX,
} from "react-icons/fi";
import { scroller } from "react-scroll";
import AniLink from "gatsby-plugin-transition-link/AniLink";

// Internal
import { name, links } from "../../../../config";
import { STATIC_PFP_URL } from "../../../utils/constants/projects";
import { fontFamily, colors, spacing, breakpoints } from "../../../../theme";

// Components
import { Flex, getLinkClassName } from "../../../styles/global-styles";
import Button from "../../form/Button";
import IconButton from "../../form/IconButton";
import Link from "../../Link";

// Hooks
import useScrollBlock from "../../../hooks/use-scroll-block";

// State
import { safeWindow } from "../../../utils/helpers/ssr";

const MobileOnly = styled.div`
  display: contents;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    display: none;
  }
`;

const DesktopOnly = styled.div`
  display: none;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    display: contents;
  }
`;

// data
const socialLinks = [
  {
    name: "twitter",
    icon: <FiTwitter size="20px" color={colors.iconAccent} />,
    link: links.twitter,
  },

  {
    name: "linkedin",
    icon: <FiLinkedin size="20px" color={colors.iconAccent} />,
    link: links.linkedin,
  },

  {
    name: "instagram",
    icon: <FiInstagram size="20px" color={colors.iconAccent} />,
    link: links.instagram,
  },

  {
    name: "email",
    icon: <FiMail size="20px" color={colors.iconAccent} />,
    link: links.email,
  },
  {
    name: "github",
    icon: <FiGithub size="20px" color={colors.iconAccent} />,
    link: links.github,
  },
];

const HamburgerMenuButton = styled(IconButton)``;

const SocialLink = styled(IconButton)`
  margin: ${spacing(1)} ${spacing(3)};
`;

const StyledButton = styled(Button)`
  margin: 0 12px 0 auto;
`;
const NavDrawerLink = styled.a.attrs({
  className: getLinkClassName("default"),
})`
  display: block;
  padding: 12px;
  font-size: 32px;
  font-family: ${fontFamily.extraBold};
  margin: 20px 40px;
`;

// styles
const WebsiteName = styled.h2`
  font-size: 14px;
  font-family: ${fontFamily.bold};
  // font-family: "Plus Jakarta Sans Bold";
  letter-spacing: 0.5%;
  cursor: pointer;
  margin-left: ${spacing(1)};
  color: inherit;
  text-decoration: none;

  @media only screen and (min-width: 350px) {
    font-size: 16px;
  }

  @media only screen and (min-width: ${breakpoints.tablet}) {
    margin-left: ${spacing(4)};
    font-size: 20px;
  }

  &:focus-visible {
    outline: 2px solid ${colors.linkHover.light};
    outline-offset: 2px;
  }
`;

const BrandHomeLink = styled.a`
  display: block;
  flex-shrink: 0;
  color: inherit;
  text-decoration: none;
  border-radius: 50%;

  &:focus-visible {
    outline: 2px solid ${colors.linkHover.light};
    outline-offset: 2px;
  }
`;

const NavigationDrawer = styled.div`
  position: fixed;
  background: white;
  width: 100%;
  height: ${safeWindow.innerHeight}px;
  z-index: 3;
  top: 60px;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    display: none;
  }
`;

const HeaderContainer = styled(Flex)`
  height: 60px;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
  background: ${colors.white};

  position: fixed;
  top: 0;
  z-index: 20;
  width: calc(100% - 4px);

  @media only screen and (min-width: 450px) {
    padding: 0 12px;
    width: calc(100% - 24px);
  }

  @media only screen and (min-width: ${breakpoints.tablet}) {
    height: 80px;
    padding: 0 24px;
  }
`;

const LinkContainer = styled.div``;

const SocialLinksContainer = styled.div`
  display: flex;
  position: absolute;
  bottom: 60px;
`;

const SideContainer = styled.div`
  margin: 0 0 0 auto;
  display: flex;
  align-items: center;
`;

const AllDesktopLinkContainer = styled.div`
  margin-right: 18px;
  display: flex;
`;

const DesktopLinkContainer = styled.div`
  margin-right: ${(props) => (props.$isBlog ? "0" : "12px")};
  width: ${(props) => (props.$isBlog ? "70px" : "100px")};
  text-align: center;
`;

const ImageWrapper = styled.div`
  height: 48px;
  width: 48px;
  border-radius: 50%;
  cursor: pointer;
  overflow: hidden;
  flex-shrink: 0;
  background: ${colors.medium};

  img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }
`;

const data = [
  {
    label: "Home",
    path: "/",
    name: "hero",
    isCTA: false,
    isDesktop: false,
    isMobile: true,
  },
  {
    label: "Projects",
    path: "/projects/",
    name: "projects",
    isCTA: false,
    isDesktop: true,
    isMobile: true,
  },
  {
    label: "Testimonials",
    path: "/testimonials/",
    name: "testimonials",
    isCTA: false,
    isDesktop: true,
    isMobile: true,
  },
  {
    label: "Blog",
    path: "/blog/",
    name: "blog",
    isCTA: false,
    isDesktop: true,
    isMobile: true,
  },
  {
    label: "About",
    path: "/about/",
    name: "aboutMe",
    isCTA: false,
    isDesktop: false,
    isMobile: true,
  },
  {
    label: "Resume",
    path: "/resume/",
    name: "resume",
    isCTA: false,
    isDesktop: true,
    isMobile: true,
  },
  {
    label: "Contact Me",
    path: "/contact-me/",
    name: "contactMe",
    isCTA: true,
    isDesktop: true,
    isMobile: true,
  },
];

const StyledAniLink = styled(AniLink).attrs({
  className: getLinkClassName("default"),
})`
  font-size: 16px;
  font-family: ${fontFamily.regular};
  font-weight: normal;
`;

const Header = () => {
  const { pathname } = useLocation();
  const isHomepage = pathname === "/";

  const [isNavigationDrawerOpen, setNavigationDrawerVisibility] = useState();

  const [blockScroll, allowScroll] = useScrollBlock();

  const navigatesToPageOnly = (name) => {
    const pageOnlyDataNames = ["aboutMe", "resume"];
    return pageOnlyDataNames.includes(name);
  };

  const handleToggle = () => {
    if (isNavigationDrawerOpen) {
      setNavigationDrawerVisibility(false);
      allowScroll();
    } else {
      setNavigationDrawerVisibility(true);
      blockScroll();
    }
  };

  const handleHomeClick = (event) => {
    // if current page is landing page then scroll to the required section, else redirect to individual page
    // navigate("/");
    if (isHomepage) {
      event?.preventDefault();
      scroller.scrollTo("hero", {
        duration: 700,
        smooth: true,
        offset: -80,
      });
    } else {
      // navigate("/");
    }
  };

  const handleNavigation = (navItem, event) => {
    if (isHomepage && !navigatesToPageOnly(navItem.name)) {
      event?.preventDefault();
      scroller.scrollTo(navItem.name, {
        duration: 700,
        smooth: true,
        offset: -80,
      });
    } else {
      // navigate(navItem.path);
    }
  };

  // scroll
  // const handleHomePage

  const closeNavigationDrawer = () => {
    setNavigationDrawerVisibility(false);
    allowScroll();
  };

  const closeAndNavigate = (navItem, event) => {
    closeNavigationDrawer();
    handleNavigation(navItem, event);
  };

  const mobileCtas = data.filter(({ isCTA, isMobile }) => isCTA && isMobile);
  const desktopLinks = data.filter(
    ({ isCTA, isDesktop }) => !isCTA && isDesktop,
  );
  const desktopCtas = data.filter(({ isCTA, isDesktop }) => isCTA && isDesktop);

  return (
    <>
      <HeaderContainer>
        <MobileOnly>
          <HamburgerMenuButton
            onClick={handleToggle}
            iconColor={colors.black}
            ariaLabel={
              isNavigationDrawerOpen ? "Close navigation menu" : "Open navigation menu"
            }
          >
            {!isNavigationDrawerOpen && <FiMenu size="30px" />}
            {isNavigationDrawerOpen && <FiX size="30px" />}
          </HamburgerMenuButton>
        </MobileOnly>

        <DesktopOnly>
          {isHomepage ? (
            <BrandHomeLink
              href="#hero"
              onClick={handleHomeClick}
              aria-label="Parmeet Singh — Home"
            >
              <ImageWrapper>
                <img
                  src={STATIC_PFP_URL}
                  alt=""
                  width={48}
                  height={48}
                  loading="eager"
                />
              </ImageWrapper>
            </BrandHomeLink>
          ) : (
            <StyledAniLink cover bg="#000" to="/" aria-label="Parmeet Singh — Home">
              <ImageWrapper>
                <img
                  src={STATIC_PFP_URL}
                  alt=""
                  width={48}
                  height={48}
                  loading="eager"
                />
              </ImageWrapper>
            </StyledAniLink>
          )}
        </DesktopOnly>

        {isHomepage ? (
          <WebsiteName as="a" href="#hero" onClick={handleHomeClick}>
            {name}
          </WebsiteName>
        ) : (
          <StyledAniLink cover bg="#000" to="/">
            <WebsiteName as="span">{name}</WebsiteName>
          </StyledAniLink>
        )}

        <SideContainer>
          <MobileOnly>
            {mobileCtas.map((navItem) => {
              if (isHomepage) {
                return (
                  <StyledButton
                    size="small"
                    onClick={(event) => handleNavigation(navItem, event)}
                    key={navItem.name}
                  >
                    {navItem.label}
                  </StyledButton>
                );
              }

              return (
                <StyledButton
                  forwardedAs={AniLink}
                  cover
                  bg="#000"
                  to={navItem.path}
                  size="small"
                  key={navItem.name}
                >
                  {navItem.label}
                </StyledButton>
              );
            })}
          </MobileOnly>

          <DesktopOnly>
            <AllDesktopLinkContainer>
              {desktopLinks.map((navItem) => {
                if (isHomepage && !navigatesToPageOnly(navItem.name)) {
                  return (
                    <DesktopLinkContainer
                      key={navItem.name}
                      $isBlog={navItem.name === "blog"}
                    >
                      <Link
                        href={`#${navItem.name}`}
                        onClick={(event) => handleNavigation(navItem, event)}
                      >
                        {navItem.label}
                      </Link>
                    </DesktopLinkContainer>
                  );
                }
                return (
                  <DesktopLinkContainer
                    key={navItem.name}
                    $isBlog={navItem.name === "blog"}
                  >
                    <StyledAniLink cover bg="#000" to={navItem.path}>
                      {navItem.label}
                    </StyledAniLink>
                  </DesktopLinkContainer>
                );
              })}
            </AllDesktopLinkContainer>
            {desktopCtas.map((navItem) => {
              if (isHomepage) {
                return (
                  <StyledButton
                    onClick={(event) => handleNavigation(navItem, event)}
                    key={navItem.name}
                  >
                    {navItem.label}
                  </StyledButton>
                );
              }
              return (
                <StyledButton
                  forwardedAs={AniLink}
                  cover
                  bg="#000"
                  to={navItem.path}
                  key={navItem.name}
                >
                  {navItem.label}
                </StyledButton>
              );
            })}
          </DesktopOnly>
        </SideContainer>
      </HeaderContainer>

      {isNavigationDrawerOpen && (
        <NavigationDrawer>
          <LinkContainer>
            {data
              .filter(({ isMobile, name }) => isMobile && name !== "contactMe")
              .map((navItem) =>
                isHomepage && !navigatesToPageOnly(navItem.name) ? (
                  <NavDrawerLink
                    href={`#${navItem.name}`}
                    onClick={(event) => closeAndNavigate(navItem, event)}
                    key={navItem.name}
                  >
                    {navItem.label}
                  </NavDrawerLink>
                ) : (
                  <StyledAniLink
                    cover
                    bg="#000"
                    to={navItem.path}
                    key={navItem.name}
                    onClick={closeNavigationDrawer}
                  >
                    <NavDrawerLink as="span">{navItem.label}</NavDrawerLink>
                  </StyledAniLink>
                ),
              )}
          </LinkContainer>
          <SocialLinksContainer>
            {socialLinks.map((item) => (
              <SocialLink
                href={item.link}
                key={item.name}
                target="_blank"
                ariaLabel={item.name}
              >
                {item.icon}
              </SocialLink>
            ))}
          </SocialLinksContainer>
        </NavigationDrawer>
      )}
    </>
  );
};
export default Header;
